import { render, staticRenderFns } from "./MarketingModules.vue?vue&type=template&id=a57632c2&scoped=true&lang=html&"
import script from "./MarketingModules.vue?vue&type=script&lang=js&"
export * from "./MarketingModules.vue?vue&type=script&lang=js&"
import style0 from "./MarketingModules.vue?vue&type=style&index=0&id=a57632c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57632c2",
  null
  
)

export default component.exports